<template>
    <div class="quick-ship__wrapper">
        <div class="quick-ship__text">
            <!--<span class="icon-quickship-bg"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
            <h6 class="quick-ship__header">{{ displayName }}</h6>-->
	        <img src="https://images.baldwinhardware.com/is/image/Baldwin/quickship-tiny?wid=121&qlt=100&op_sharpen=1" alt="Quick Ship" class="mr-2">
	        <p class="quick-ship__description" v-html="description"></p>
            <div v-if="tooltip" class="form-group__tooltip">
                <IconTooltip :tooltipMessage="tooltip" :isIcomoonIcon="true" iconClass="icon-info" :isHtml="true"></IconTooltip>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Cta from './shared/Cta.vue';
import IconTooltip from "Vue/components/lockDesigner/components/shared/IconTooltip.vue";

export default {
    name: 'QuickShip',

    components: {
        Cta,
        IconTooltip
    },
    props: {
        imageUrl: {
            type: String,
            default: '',
        },
        displayName: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: null,
        },
        route: {
            type: String,
            default: '',
        },
        tooltip: {
            type: String,
            default: '',
        }
    },
    methods: {
        onSwitchChange(isSelected: boolean) {
            console.log({ isSelected });
        },
    },
    mounted() {},
};
</script>
